import { v4 as uuidv4 } from 'uuid';

const Data=()=>{
    return(
        [
            {
                name:"Tropical Midnight",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=31516",
                cover:"https://i.scdn.co/image/ab67616d0000b273e549d483392cc98fa3328ccb",
                color:["#4ba252","#9aadbc"],
                active:true,
                artist:"C Y G N",
                id:uuidv4()
            },
            {
                name:"Vision Nocturne",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=31608",
                cover:"https://i.scdn.co/image/ab67616d0000b2737ab7b8be6a89e935df5d7474",
                color:["#4ba252","#9aadbc"],
                active:false,
                artist:"C Y G N",
                id:uuidv4()
            },
            {
                name:"Lavender",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=30086",
                cover:"https://i.scdn.co/image/ab67616d0000b2732254728af1d599d01f3f3da4",
                color:["#781738","#fde5cf"],
                active:false,
                artist:"Mdjsty",
                id:uuidv4()
            },
            {
                name:"Embers",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=30135",
                cover:"https://i.scdn.co/image/ab67616d0000b2738ba0f5ac658406e23b219efb",
                color:["#173847","#d16e5a"],
                active:false,
                artist:"Molly McPhaul, Enluv",
                id:uuidv4()
            },
            {
                name:"Reflections",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=32854",
                cover:"https://i.scdn.co/image/ab67616d0000b273609989517da2836064d2c051",
                color:["#e892b7","#f5f1a9"],
                active:false,
                artist:"King | Divine",
                id:uuidv4()
            },
            {
                name:"Lake Placid",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=30337",
                cover:"https://i.scdn.co/image/ab67616d0000b27398c32eb568ad47784a2e7883",
                color:["#38494f","#1b4040"],
                active:false,
                artist:"The Doppelgangaz",
                id:uuidv4()
            },
            {
                name:"Overgrowth",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=30107",
                cover:"https://i.scdn.co/image/ab67616d0000b273cbb1a24fa0207c742c1715a7",
                color:["#ebbcb4","#707a80"],
                active:false,
                artist:"Kendall Miles",
                id:uuidv4()
            },
            {
                name:"Soulsounds",
                audio:"https://mp3.chillhop.com/serve.php/?mp3=27500",
                cover:"https://i.scdn.co/image/ab67616d0000b2730f571abe472289e236d83de5",
                color:["#fa9a9d","#1d2b39"],
                active:false,
                artist:"Parkbench Epiphany",
                id:uuidv4()
            }
        ]
    )
}

export default Data;